import {GeoPoint, Trail} from '../models';

export class TrailsState {
  all: Trail[];
  my: Trail[];
  geoLocation: GeoPoint;
  zoom: number;
}
